import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="border-t border-navy-800 bg-navy-950 py-12 md:py-20" data-id="element-61">
      <div className="container mx-auto px-4" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative mx-auto max-w-4xl overflow-hidden rounded-2xl border border-navy-700 bg-gradient-to-br from-navy-900 to-navy-950 p-4 text-center sm:p-6 md:p-12" data-id="element-63">
          <ShieldCheck className="pointer-events-none absolute right-0 top-0 h-64 w-64 p-8 text-white opacity-5" data-id="element-64" />

          <div className="relative z-10" data-id="element-65">
            <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full bg-green-500/10 text-green-500 md:mb-6 md:h-20 md:w-20" data-id="element-66">
              <ShieldCheck className="h-8 w-8 md:h-10 md:w-10" data-id="element-67" />
            </div>
            <h2 className="mb-2 font-oswald text-lg uppercase tracking-wide text-gray-400 sm:text-xl sm:tracking-widest" data-id="element-68">
              YOUR INVESTMENT IS 100% PROTECTED
            </h2>
            <h3 className="mb-6 font-anton text-3xl uppercase tracking-wide text-white sm:text-4xl md:mb-8 md:text-5xl" data-id="element-69">
              7-DAY FULL GUARANTEE
            </h3>

            <div className="prose prose-lg prose-invert mx-auto text-gray-300" data-id="element-70">
              <p className="mb-3 text-base font-medium leading-7 text-white md:mb-4 md:text-xl" data-id="element-71">
                Your money is completely protected.
              </p>
              <p className="mb-4" data-id="element-72">
                You have 7 full days to explore all 6 volumes, use the session
                libraries, test the premium bonuses, and evaluate the entire
                system.
              </p>
              <p className="mb-8" data-id="element-73">
                If you&apos;re not completely satisfied that this will save you
                hours of work, simply request a refund and we&apos;ll return
                100% of your purchase.
              </p>
              <div className="font-oswald text-lg uppercase tracking-normal text-gold-500 md:text-2xl md:tracking-wider" data-id="element-74">
                Zero Risk For You.
                <br data-id="element-75" />
                Complete Commitment From Us.
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}